module.exports = __webpack_public_path__ + "media/images/projects/12-dashboard-6e3db46adca196cc6aa278b0046d23bf.jpg";